import React, { FC } from "react"
import Spinner from "./Spinner"
import { SpinnerBlockProps } from "./Spinner.types"

const SpinnerBlock: FC<SpinnerBlockProps> = ({
    title,
    inverted,
    third,
    spinnerProps,
    wrapperProps,
    ...props
}: SpinnerBlockProps) => {
    let klass = `zb-loader-block`
    if (inverted) klass += " zb-loader-block-inverted"

    if (third) {
        klass += " zb-loader-block-3rd"

        if (!props.style) {
            props.style = {
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            }
        }

        return (
            <div
                style={{
                    position: "relative",
                    ...wrapperProps,
                }}
            >
                {getContent()}
            </div>
        )
    }

    function getContent() {
        return (
            <div className={klass} {...props}>
                <div className="zb-loader-content">
                    <Spinner {...spinnerProps} />
                    <span className="zb-loader-text">{title}</span>
                </div>
            </div>
        )
    }

    return getContent()
}

export default SpinnerBlock
